/*!
 * @utiljs/param 0.6.6 (http://git.sankuai.com/projects/WM/repos/utiljs/browse/param/)
 * API http://git.sankuai.com/projects/WM/repos/utiljs/browse/param/doc/api.md
 * Copyright 2017-2019 美团mfe. All Rights Reserved
 * Licensed under MIT (http://git.sankuai.com/projects/WM/repos/utiljs/browse/param/LICENSE)
 */

import { type } from '@utiljs/type';
import { extend } from '@utiljs/extend';

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function parseUrl(url) {
  if (typeof url !== 'string') {
    throw new TypeError('TypeError');
  }

  var parse_url = /^(?:([A-Za-z]+):)?(\/\/)?((?:(?:[0-9\-A-Za-z]+\.)+[0-9\-A-Za-z]+)|localhost)?(?::(\d+))?(\/)?([^?#]*)?(?:\?([^#]*))?(?:#(.*))?$/;
  var result = parse_url.exec(url);
  var fields = ['url', 'scheme', 'slashDouble', 'host', 'port', 'slash', 'path', 'query', 'hash']; // path 不带首位 /
  // query 不带 ？
  // hash 不带 #

  var fiedldObj = {};
  fields.forEach(function (field, i) {
    fiedldObj[field] = result[i];
  });
  return fiedldObj;
}

function stringify(obj) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (type(obj) !== 'object') {
    return '';
  }

  var opt = extend({
    sep: '&',
    eq: '=',
    addQueryPrefix: false,
    encode: function encode(x, isKey) {
      return encodeURIComponent(x);
    },
    filter: function filter(v, k) {
      return true;
    },
    // undefined or null > ''
    convert: function convert(v, k) {
      return typeof v === 'undefined' || v === null ? '' : v;
    },
    reduce: false // (prev, v, k) => prev

  }, option);
  var res = [];
  var isEncode = type(opt.encode) === 'function';

  for (var key in obj) {
    if (hasOwnProp(obj, key) && opt.filter(obj[key], key)) {
      if (type(opt.reduce) === 'function') {
        res = opt.reduce(res, obj[key], key);
      } else {
        res.push({
          k: key,
          v: String(opt.convert(obj[key], key))
        });
      }
    }
  }

  var str = '';

  for (var i = 0; i < res.length; i++) {
    var k = isEncode ? opt.encode(res[i].k, true) : res[i].k;
    var v = isEncode ? opt.encode(res[i].v) : res[i].v;
    str = str + (str === '' ? '' : opt.sep) + k + opt.eq + v;
  }

  return opt.addQueryPrefix ? '?' + str : str;
}
function parse(str) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof str === 'undefined') {
    return null;
  }

  str = String(str);
  var opt = extend({
    sep: '&',
    eq: '=',
    ignoreQueryPrefix: false,
    decode: function decode(x, iskey) {
      return decodeURIComponent(x);
    },
    filter: function filter(v, k) {
      return true;
    },
    convert: function convert(v, k) {
      return v;
    },
    reduce: false // (prev, v, k) => prev

  }, option); // 处理?，?a=b

  if (!opt.ignoreQueryPrefix) {
    var _arr = str.split('?');

    str = _arr.length === 2 ? _arr[1] : _arr[0];
  }

  var res = {};
  var arr = str.split(opt.sep);
  var isDecode = type(opt.decode) === 'function';

  for (var i = 0; i < arr.length; i++) {
    var arr2 = arr[i].split(opt.eq);
    var k = isDecode ? opt.decode(arr2[0], true) : arr2[0];
    var v = isDecode ? opt.decode(arr2[1]) : arr2[1];

    if (opt.filter(v, k)) {
      if (type(opt.reduce) === 'function') {
        res = opt.reduce(res, v, k);
      } else {
        res[k] = opt.convert(v, k);
      }
    }
  }

  return res;
}
function getUrlParam(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = String(name);
  url = String(url);
  var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url);

  if (!results) {
    return '';
  }

  return results[1] ||
  /* istanbul ignore next */
  '';
}
function updateURLParam(url, param, paramVal) {
  if (paramVal === null || paramVal === undefined) {
    paramVal = '';
  }

  if (typeof url === 'string' && typeof param === 'string' && (typeof paramVal === 'string' || typeof paramVal === 'boolean' || typeof paramVal === 'number')) {
    var TheAnchor = null;
    var newAdditionalURL = '';
    var tempArray = url.split('?');
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = '';
    var tmpAnchor = '';
    var TheParams = '';

    if (additionalURL) {
      tmpAnchor = additionalURL.split('#');
      TheParams = tmpAnchor[0];
      TheAnchor = tmpAnchor[1];

      if (TheAnchor) {
        additionalURL = TheParams;
      }

      tempArray = additionalURL.split('&');

      for (var i = 0; i < tempArray.length; i++) {
        if (tempArray[i].split('=')[0] !== param) {
          newAdditionalURL += temp + tempArray[i];
          temp = '&';
        }
      }
    } else {
      tmpAnchor = baseURL.split('#');
      TheParams = tmpAnchor[0];
      TheAnchor = tmpAnchor[1];

      if (TheParams) {
        baseURL = TheParams;
      }
    }

    if (TheAnchor) {
      paramVal += '#' + TheAnchor;
    }

    var rowsTxt = temp + '' + param + '=' + paramVal;
    return baseURL + '?' + newAdditionalURL + rowsTxt;
  } else {
    throw new TypeError('TypeError');
  }
}
function getRestUrl(url) {
  var parseObject = parseUrl(url);
  return "".concat(parseObject.slash ? parseObject.slash : '').concat(parseObject.path ? parseObject.path : '').concat(parseObject.query ? '?' + parseObject.query : '').concat(parseObject.hash ? '#' + parseObject.hash : '');
}
function getPath(url) {
  var parseObject = parseUrl(url);

  if (!parseObject.path) {
    return '/';
  }

  return "".concat(parseObject.slash ? parseObject.slash : '').concat(parseObject.path);
}
function getHash(url) {
  var parseObject = parseUrl(url);
  return "".concat(parseObject.hash ? '#' + parseObject.hash : '');
}

export { stringify, parse, getUrlParam, updateURLParam, getRestUrl, getPath, getHash };
